/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-12",
    versionChannel: "nightly",
    buildDate: "2025-06-12T00:06:54.905Z",
    commitHash: "71d972dc8d096a935909025c49d9c86f96e17f7f",
};
